import React from 'react';
import { Modal } from 'antd';
import { Button } from 'components/atoms';

interface CheckDuplicateModalProps {
  visible: boolean;
  title: string;
  message: string;
  onCancel?: () => void;
  onOk: () => void;
}

const CheckDuplicateModal = ({
  visible,
  title,
  message,  
  onCancel,
  onOk,
}: CheckDuplicateModalProps): React.ReactElement => {
  /* ======================================================
   * methods
   * ====================================================== */
  const getButtons = () => (
    <div className="text-center">
      <Button
        type="primary"
        onClick={() => onOk()}
      >
        확인
      </Button>
      {onCancel && (<Button onClick={() => onCancel()}>취소</Button>)}
    </div>
  );

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Modal title={title} open={visible} footer={getButtons()} onCancel={onCancel} centered>
      <p style={{whiteSpace:"pre-wrap"}}>{message}</p>
    </Modal>
  );
};

export default CheckDuplicateModal;
